import { render, staticRenderFns } from "./notificationSetting.vue?vue&type=template&id=56103bb0&scoped=true&"
import script from "./notificationSetting.vue?vue&type=script&lang=js&"
export * from "./notificationSetting.vue?vue&type=script&lang=js&"
import style0 from "./notificationSetting.vue?vue&type=style&index=0&id=56103bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56103bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56103bb0')) {
      api.createRecord('56103bb0', component.options)
    } else {
      api.reload('56103bb0', component.options)
    }
    module.hot.accept("./notificationSetting.vue?vue&type=template&id=56103bb0&scoped=true&", function () {
      api.rerender('56103bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/components/notificationSetting.vue"
export default component.exports